import { createState } from '@hookstate/core';

const ErrorState = createState<string>('');

export default ErrorState;
